export const styles = (theme) => ({
  assignContainer: {
    width: "100%",
    maxHeight: 550,
    marginTop: 20,
    padding: "0 20px",
    overflowY: "auto",
  },
  subtitle: {
    color: "#737273",
    fontSize: 14,
    fontWeight: 500,
  },
  clinicianInfo: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    alignItems: "flex-end",
    justifyContent: "space-between",
    padding: "10px 0",
  },
  clinicianName: {
    fontSize: 16,
    fontWeight: 500,
    color: "#1517d",
  },
  clinicianAvailabilityInfoContainer: {
    display: "flex",
    flexDirection: "column",
    border: "1px solid #c6c6c6",
    borderRadius: 8,
    margin: "10px 0",
    padding: 10,
    boxSizing: "border-box",
  },
  clinicianAvailabilityInfo: {
    display: "flex",
    alignItems: "center",
  },
  clinicianAvailabilityBasicInfo: {
    width: "90%",
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginLeft: 10,
    paddingTop: 20,
    boxSizing: "border-box",
  },
  availabilityRole: {
    fontSize: 13,
    color: "#404040",
  },
});
